import type { FacilityDetail, LocationCheckResult, LocationCheckSummary } from "./types";

type ApiFetch = (path: string, init?: RequestInit) => Promise<Response>;

export const RECENT_CHECK_DAYS = 7;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export async function runLocationCheck(apiFetch: ApiFetch, registryId: string): Promise<LocationCheckResult> {
  const response = await apiFetch(`facilities/${encodeURIComponent(registryId)}/location-check`, { method: "POST" });
  return response.json();
}

export async function lastLocationCheck(apiFetch: ApiFetch, registryId: string): Promise<LocationCheckSummary | null> {
  const response = await apiFetch(`facilities/${encodeURIComponent(registryId)}/location-check`);
  return response.json();
}

export async function applyAddressPoint(
  apiFetch: ApiFetch,
  registryId: string,
  checkId: number,
): Promise<FacilityDetail> {
  const response = await apiFetch(`facilities/${encodeURIComponent(registryId)}/location-check/apply`, {
    method: "POST",
    body: JSON.stringify({ checkId }),
  });
  return response.json();
}

export function isRecentCheck(checkedUtc: string, now: Date = new Date()): boolean {
  const checked = new Date(/[zZ]|[+-]\d\d:\d\d$/.test(checkedUtc) ? checkedUtc : `${checkedUtc}Z`);
  return now.getTime() - checked.getTime() < RECENT_CHECK_DAYS * MS_PER_DAY;
}
